/// <amd-module name="SuiteCommerce.CookieConsent.Common.Cookies"/>
define("SuiteCommerce.CookieConsent.Common.Cookies", ["require", "exports", "jQuery"], function (require, exports, jQuery) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Cookies = /** @class */ (function () {
        function Cookies() {
            try {
                Cookies.JSCookies = require('js.cookie');
            }
            catch (_a) { }
        }
        Cookies.getInstance = function () {
            if (!Cookies.instance) {
                Cookies.instance = new Cookies();
            }
            return Cookies.instance;
        };
        Cookies.prototype.get = function (name) {
            if (Cookies.JSCookies) {
                return Cookies.JSCookies.get(name);
            }
            return jQuery.cookie(name);
        };
        Cookies.prototype.set = function (name, value, expires) {
            if (Cookies.JSCookies) {
                Cookies.JSCookies.set(name, value, expires);
            }
            else {
                jQuery.cookie(name, value, expires);
            }
        };
        return Cookies;
    }());
    exports.default = Cookies;
});
